import { get, post, put, _delete } from './Tools';


  const uploadCertificadosCompany = async (payload) => {
    const response = await post(
      `${process.env.REACT_APP_SERVER}upload_files_company/upload-certificados`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
    return response;
  };
  
  const getCertificadosCompany = async (registroId) => {
    const response = await get(
      `${process.env.REACT_APP_SERVER}upload_files_company/registros-patronales/${registroId}/certificados`
    );
    return response;
  };

export { 
  uploadCertificadosCompany,
  getCertificadosCompany
};